<template>
  <div class="mb-2">
    <div class="font-size-10 text-muted">{{ label }}</div>
    <div class="font-size-14">
      {{ date }}
    </div>
  </div>
</template>

<script>
import { formatDateOnly } from "../../../assets/js/common";
export default {
  props: {
    value: {},
    label: {},
  },
  computed: {
    date() {
      if (!this.value) return "";
      return formatDateOnly(this.value);
    },
  },
};
</script>

<style>
</style>